/*
Created by daisy on 2020/8/11
*/

//时间戳转日期处理，不足10补0
const addZero = (m) => { return m < 10 ? '0' + m : m };
const timeFormat = (timestamp) => {
    let time = new Date(timestamp * 1000);
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let date = time.getDate();
    let hours = time.getHours();
    let minutes = time.getMinutes();
    return year + '.' + addZero(month) + '.' + addZero(date) + ' ' + addZero(hours) + ':' + addZero(minutes);
}

export default timeFormat;



// WEBPACK FOOTER //
// ./src/utils/timeFormat.js